/**
 * WHEN THE PASS ENDS, THE WORK STAYS.
 *
 * A season of quotes is the reason a contractor comes back next October, so
 * nothing is deleted and nothing is hidden when a pass lapses. He signs in, he
 * sees every customer, every job, every quote he ever wrote, and he can open
 * and read all of it. What he cannot do is make anything new.
 *
 * Look for free, work for money. It is also the only version of this that is
 * honest: his customers' details are his, and holding them hostage to get a
 * renewal is not a business I would want to be in.
 *
 * ONE GUARD, NOT A HUNDRED CHECKS. The store has over a hundred places that
 * change the document, and a rule enforced at each of them is a rule that is
 * missing from the one somebody adds next month. So the store's set() is
 * wrapped once and drops any change to the document while this is false. The
 * interface still works - panels open, runs select, the photo pans - because
 * none of that is the document.
 *
 * LOADING IS NOT EDITING. Opening a saved job replaces the document, and it
 * has to keep working when a pass has lapsed or the whole idea collapses. So
 * there is one named escape, and reading its call sites is how you audit this:
 * loading a job, and pulling from the server.
 */

let editable = true
let loadingDepth = 0

export const canEdit = () => editable || loadingDepth > 0

/** Set from the auth store whenever the pass state changes. */
export function setCanEdit(v: boolean) {
  editable = v
}

/** True when the pass has lapsed, for the interface to say so. */
export const isReadOnly = () => !editable

/**
 * Replacing the document because it was loaded, not because somebody drew.
 *
 * Counted rather than a boolean, so a nested call cannot switch it off early
 * and leave the rest of an outer load silently dropped.
 */
export function loading<T>(fn: () => T): T {
  loadingDepth++
  try {
    return fn()
  } finally {
    loadingDepth--
  }
}
